'use client'
import cl from 'clsx'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import arrow from '@/public/icons/arrow-top.svg'
import AccountModal from '../account-modal'
import Link from 'next/link'
import routes from '@/utils/routes'
import styles from './styles.module.css'
import useAuthStore from '@/store/auth'
import SignUp from "@/components/sign-up";
import LogIn from "@/components/log-in";

const BurgerMenu = ({ dict }) => {
    const { contacts, faq, home } = dict.header
    const { tool_1, tool_2, tool_3 } = dict.discover
    const [open, setOpen] = useState(false)
    const [openSelectLanguage, setOpenSelectLanguage] = useState(false)
    const [tools, setTools] = useState(false)
    const [selectLanguageLocal, setSelectLanguageLocal] = useState('')
    const { isAuth } = useAuthStore()

    const closeBurgerMenu = () => {
        setTimeout(() => {
            setOpen(false)
        }, 1000)
    }

    const navigation = [
        { id: 1, title: dict.header.home, link: routes.main },
        { id: 2, title: dict.header.idea, link: `${routes.main}#idea`, offset: -90 },
        { id: 3, title: dict.header.tools, link: `${routes.main}#discover-top`, offset: 30 },
        { id: 4, title: dict.header.contacts, link: routes.contacts },
        { id: 5, title: dict.header.faq, link: routes.faq }
    ]

    useEffect(() => {
        if (open) {
            document.body.classList.add('burger__menu-open')
        } else {
            document.body.classList.remove('burger__menu-open')
        }

        return () => {
            document.body.classList.remove('burger__menu-open')
        }
    }, [open])

    const handleMenu = () => {
        setOpen(!open)
        setOpenSelectLanguage(false)
    }

    const handleOpenSelectLanguage = () => {
        setOpenSelectLanguage(true)
    }

    const handleSelectLanguage = (id, slag, title) => {
        setOpenSelectLanguage(false)
        selectLanguage(id, slag, title)
    }

    const languages = [
        { id: 1, slag: 'en', title: 'English', active: true },
        { id: 2, slag: 'de', title: 'Deutsch', active: false },
        { id: 3, slag: 'uk', title: 'Ukrainian', active: false }
    ]

    const selectLanguage = (id, slag) => {
        localStorage.setItem('selectLanguage', 'true')
        document.cookie = `selectedLanguage=${slag?.toLowerCase()}; path=/; max-age=31536000`
        const supportedLocales = ['en', 'uk', 'de']
        let currentPath = window.location.pathname
        let pathSegments = currentPath.split('/').filter(segment => !supportedLocales.includes(segment) && segment !== "")
        pathSegments.unshift(slag?.toLowerCase())
        const newPath = '/' + pathSegments.join('/')

        if (newPath !== currentPath) {
            window.location.href = newPath
        }
    }

    useEffect(() => {
        if (typeof document !== 'undefined') {
            const selectedLanguage = document.cookie
                .split('; ')
                .find(row => row.startsWith('selectedLanguage='))
                ?.split('=')[1]

            if (selectedLanguage) {
                setSelectLanguageLocal(selectedLanguage)
            }
        }
    }, [])

    let fullNameSelectLanguage
    switch (selectLanguageLocal) {
        case 'en':
            fullNameSelectLanguage = 'English'
            break
        case 'de':
            fullNameSelectLanguage = 'Deutsch'
            break
        case 'uk':
            fullNameSelectLanguage = 'Ukrainian'
            break
        default:
            fullNameSelectLanguage = 'English'
            break
    }

    return (
        <div className={styles.burger}>
            <div onClick={handleMenu} className={cl(styles.navIcon, open && styles.open)}>
                <span></span>
                <span></span>
            </div>

            {open && (
                !isAuth ? (
                    <div className={styles.burger__menu}>
                        <div className={styles.burger__language}>
                            <p onClick={handleOpenSelectLanguage} className={styles.burger__language_title}>
                                {fullNameSelectLanguage}
                            </p>
                            <Image className={styles.burger__arrow} src={arrow} alt='arrow-left' />
                        </div>

                        {navigation.map(({ id, title, link }) => (
                            <div onClick={closeBurgerMenu} key={id} className={styles.burger__item}>
                                <Link href={link}>{title}</Link>
                            </div>
                        ))}

                        <div className={styles.burger__buttons}>
                            <SignUp dict={dict} />
                            <LogIn dict={dict} />
                        </div>
                    </div>
                ) : (
                    <div className={cl(styles.burger__menu, styles.burger__menu_auth)}>
                        <div onClick={handleOpenSelectLanguage} className={styles.burger__language}>
                            <p className={styles.burger__language_title}>{fullNameSelectLanguage}</p>
                            <Image className={styles.burger__arrow} src={arrow} alt='arrow-left' />
                        </div>
                        <AccountModal openBurgerModal={setOpen} dict={dict} />
                        <div className={styles.burger__items}>
                            <div onClick={closeBurgerMenu} className={cl(styles.burger__item, styles.burger__item_one)}>
                                <Link href={routes.main}>{home}</Link>
                            </div>
                            <div className={cl(styles.burger__item, styles.burger__tools)}>
                                <div onClick={() => setTools(!tools)}>{dict.header.tools}</div>
                                <Image className={cl(tools && styles.burger__tools_arrow)} src={arrow} alt='arrow' />
                            </div>
                            {tools && (
                                <div className={styles.burger__tools_items}>
                                    <div onClick={closeBurgerMenu} className={styles.burger__tools_item}>
                                        <Link href={routes.pa_tool}>{tool_1}</Link>
                                    </div>
                                    <div onClick={closeBurgerMenu} className={styles.burger__tools_item}>
                                        <Link href={routes.sa_tool}>{tool_2}</Link>
                                    </div>
                                    <div onClick={closeBurgerMenu} className={styles.burger__tools_item}>
                                        <Link href={routes.lca_tool}>{tool_3}</Link>
                                    </div>
                                </div>
                            )}
                            <div onClick={closeBurgerMenu} className={styles.burger__item}>
                                <Link href={routes.contacts}>{contacts}</Link>
                            </div>
                            <div onClick={closeBurgerMenu} className={styles.burger__item}>
                                <Link href={routes.faq}>{faq}</Link>
                            </div>
                        </div>
                    </div>
                )
            )}

            {openSelectLanguage && (
                <div className={cl(styles.burger__menu_second_page, styles.burger__menu_auth)}>
                    {languages.map(({ id, slag, title }) => (
                        <div
                            key={id}
                            onClick={() => handleSelectLanguage(id, slag, title)}
                            className={cl(styles.burger__language, styles.burger__language_select)}
                        >
                            <p className={styles.burger__language_title}>{title}</p>
                            <Image className={styles.burger__arrow} src={arrow} alt='arrow-left' />
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default BurgerMenu
